import React from 'react';
import SidebarNav from '../../../node_modules/gatsby-theme-apollo-core/src/components/sidebar-nav';

export default ({alwaysExpanded, ...props}) => {
  return <SidebarNav {...props} alwaysExpanded={true} />
}